export const actors = [
  {
    id: "li-lizhen",
    name: "李丽珍",
    englishName: "Loletta Lee",
    birthYear: 1966,
    birthplace: "中国香港",
    avatar:
      "https://readdy.ai/api/search-image?query=elegant%20editorial%20portrait%20illustration%20of%20an%20East%20Asian%20woman%20in%20her%20thirties%20with%20short%20dark%20hair%2C%20calm%20confident%20expression%2C%20warm%20cream%20studio%20background%2C%20soft%20window%20light%2C%20subtle%20film%20grain%2C%20tasteful%20muted%20peach%20tones&width=600&height=600&seq=actor-li-lizhen&orientation=squarish",
    bio: [
      "中国香港演员，1980 年代以青春片出道，凭清新自然的银幕形象被观众熟知。九十年代她主动寻求角色上的转变，在《蜜桃成熟时》中塑造了一个带着犹豫与勇气的都市女孩。",
      "此后她持续活跃于电影与电视剧领域，戏路跨越文艺片、类型片与家庭题材。她曾多次在访谈中提到，表演的核心是让人物「站得住」，而不是停留在某个标签上。",
      "近年她较少出现在商业制作中，更多参与影展交流与青年影人扶持计划。",
    ],
    films: ["peach-1993", "peach-2023", "peach-2025"],
  },
  {
    id: "zhong-zhen",
    name: "钟真",
    englishName: "Jane Chung",
    birthYear: 1979,
    birthplace: "中国香港",
    avatar:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20portrait%20illustration%20of%20an%20East%20Asian%20woman%20with%20long%20wavy%20hair%2C%20soft%20gentle%20smile%2C%20cream%20and%20peach%20background%2C%20natural%20window%20lighting%2C%20cinematic%20film%20grain%2C%20elegant%20minimal%20style&width=600&height=600&seq=actor-zhong-zhen&orientation=squarish",
    bio: [
      "九十年代末进入影坛，凭系列第二部中的小雨一角受到关注。她的表演以克制见长，很少使用夸张的情绪外化，更倾向于用眼神和停顿完成表达。",
      "在《蜜桃成熟时·夏日回声》中，她时隔多年重回系列，饰演成年后的自己。她表示，这次演出像是一次对过去表演的回应。",
      "除电影外，她也参与舞台剧与独立短片创作。",
    ],
    films: ["peach-1997", "peach-1999", "peach-2023", "peach-2024"],
  },
  {
    id: "huang-rong",
    name: "黄榕",
    englishName: "Wong Yung",
    birthYear: 1982,
    birthplace: "中国香港",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20illustration%20of%20an%20East%20Asian%20woman%20with%20straight%20shoulder%20length%20hair%2C%20bright%20youthful%20expression%2C%20soft%20terracotta%20studio%20background%2C%20warm%20diffused%20light%2C%20subtle%20grain%2C%20minimal%20tasteful%20composition&width=600&height=600&seq=actor-huang-rong&orientation=squarish",
    bio: [
      "以气质清亮的银幕形象被观众记住，代表作集中在青春与都市题材。她在系列第三部中饰演的小桃，兼具童话感与人间的笨拙，成为影迷讨论度最高的角色之一。",
      "她曾在采访中提到，自己最重视的是人物「相信什么」，因为这决定了每一场戏的分寸。",
      "近年转向幕后，参与剧本策划与新人演员训练。",
    ],
    films: ["peach-1997", "peach-1999", "peach-2005"],
  },
  {
    id: "chen-jing",
    name: "陈静",
    englishName: "Dada Chan",
    birthYear: 1989,
    birthplace: "中国香港",
    avatar:
      "https://readdy.ai/api/search-image?query=modern%20editorial%20portrait%20illustration%20of%20an%20East%20Asian%20woman%20with%20sleek%20dark%20hair%2C%20confident%20direct%20gaze%2C%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20fine%20film%20grain%2C%20refined%20cinematic%20portrait%20style&width=600&height=600&seq=actor-chen-jing&orientation=squarish",
    bio: [
      "新生代演员，因系列重启作《蜜桃成熟时33D》进入大众视野。她在此后的都市题材作品中不断尝试不同类型的角色，逐渐摆脱单一印象。",
      "在《蜜桃成熟时·城市日记》里，她饰演一位回到旧区拍片的纪录片导演，角色与她自身的职业思考形成有趣互文。",
      "她长期关注城市更新与影像保存议题，并参与相关公益放映活动。",
    ],
    films: ["peach-2011", "peach-2024", "peach-2025"],
  },
  {
    id: "pan-zhenwei",
    name: "潘震伟",
    englishName: "Poon Chun-wai",
    birthYear: 1963,
    birthplace: "中国香港",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20illustration%20of%20a%20middle%20aged%20East%20Asian%20man%20with%20short%20greying%20hair%2C%20calm%20thoughtful%20expression%2C%20warm%20cream%20background%2C%20soft%20directional%20light%2C%20film%20grain%2C%20dignified%20minimal%20portrait&width=600&height=600&seq=actor-pan-zhenwei&orientation=squarish",
    bio: [
      "资深演员，活跃于八十至九十年代的香港影坛，擅长塑造内敛而克制的都市男性角色。在系列首作中，他饰演阿桃工作上的前辈。",
      "他的表演风格偏向留白，常以极少的台词完成人物关系的交代。",
      "近年主要参与剧集与舞台演出。",
    ],
    films: ["peach-1993", "peach-2011"],
  },
  {
    id: "cheng-kui-an",
    name: "成奎安",
    englishName: "Shing Fui-on",
    birthYear: 1955,
    birthplace: "中国香港",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20illustration%20of%20an%20older%20East%20Asian%20man%20with%20a%20broad%20kind%20face%2C%20subtle%20smile%2C%20warm%20brown%20studio%20background%2C%20soft%20classic%20lighting%2C%20film%20grain%2C%20nostalgic%20cinematic%20portrait&width=600&height=600&seq=actor-cheng-kui-an&orientation=squarish",
    bio: [
      "香港电影黄金时代的标志性配角演员，参演作品数量众多，以极具辨识度的外形和表演节奏留下深刻印象。",
      "在系列前两部中，他饰演的角色为影片提供了难得的日常幽默与温度。",
      "他于 2009 年离世，其作品仍是研究香港类型片的重要样本。",
    ],
    films: ["peach-1993", "peach-1999", "peach-2023"],
  },
  {
    id: "lin-wei",
    name: "林伟",
    englishName: "Lam Wai",
    birthYear: 1970,
    birthplace: "中国香港",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20illustration%20of%20an%20East%20Asian%20man%20in%20his%20forties%20with%20short%20dark%20hair%20and%20light%20stubble%2C%20relaxed%20mood%2C%20warm%20sand%20colored%20background%2C%20soft%20natural%20light%2C%20cinematic%20grain&width=600&height=600&seq=actor-lin-wei&orientation=squarish",
    bio: [
      "影视双栖演员，擅长在群像戏中塑造鲜明的普通人形象。他在系列多部作品中担任重要配角，是连接不同年代故事的稳定存在。",
      "他习惯于在开拍前为角色写一份生活年表，以此确定人物的说话方式与步态。",
      "近年参与多部独立制作。",
    ],
    films: ["peach-1997", "peach-2005", "peach-2011", "peach-2025"],
  },
  {
    id: "zhou-jialing",
    name: "周嘉玲",
    englishName: "Valerie Chow",
    birthYear: 1970,
    birthplace: "中国香港",
    avatar:
      "https://readdy.ai/api/search-image?query=elegant%20editorial%20portrait%20illustration%20of%20an%20East%20Asian%20woman%20with%20short%20styled%20hair%2C%20poised%20expression%2C%20warm%20ivory%20background%2C%20soft%20studio%20lighting%2C%20subtle%20film%20grain%2C%20refined%20minimal%20fashion%20portrait&width=600&height=600&seq=actor-zhou-jialing&orientation=squarish",
    bio: [
      "九十年代活跃于香港影坛的演员与模特，出演多部都市题材作品。她的银幕气质冷静疏离，常被安排饰演掌握关键信息的配角。",
      "在系列外传《青春纪事》中，她饰演三位女孩的学姐，是影片中唯一「已经长大」的参照系。",
      "此后逐渐淡出幕前，转向生活方式领域。",
    ],
    films: ["peach-2005", "peach-2024"],
  },
];

export const sortActorsByFilmCount = [...actors].sort((a, b) => b.films.length - a.films.length);